import * as Yup from 'yup';
import { TFunction } from 'react-i18next';
import { FEE_TYPE } from '../../components/application/NewApplication';
import { PARTNER_FORM_FIELDS } from '../new-partner/new-partner-form';
import { BUSINESS_INFO_FORM_FIELDS } from '../profile-settings/business-settings-business-information-form';
import { DEVELOPER_FORM_FIELDS } from '../profile-settings/bussiness-settings-developer-details-form';
import { CUSTOMER_SUPPORT_FORM_FIELDS } from '../profile-settings/bussiness-settings-customer-support-form';
import { FORM_FIELDS as SITE_FORM_FIELDS } from '../sites/site-form';
import { PAYMENTS_GATEWAY_FORM_FIELDS } from '../payments-gateway/payments-gateway-form';
import { Shape } from '../yup_types';
import { BANK_FORM_FIELD } from '../merchant/bank-form';
import { CONTACT_FORM_FIELDS } from '../merchant/contact-form';
import { FORM_FIELDS as USERS_FORM_FIELDS } from '../users/userModalUtils';
import { AGENT_FORM_FIELDS } from '../new-agent/new-agent-form';
import { PROFILE_SETTINGS_FORM_FIELDS } from '../profile-settings/profile-settings-form';
import { CHANGE_PASSWORD_FORM_FIELDS } from '../profile-settings/account-security/change-password-form';
import { ACCOUNT_FORM_FIELDS } from '../accounts/account-form';
import { CONTACT_FORM_FIELDS as CONTACT_PAGE_FORM_FIELDS } from '../add-contact/add-contact-form';
import React, { ReactNode } from 'react';
import { OWNER_FORM_FIELDS } from '../merchant/owner-form';
import { AGENCY_FORM_FIELD } from '../new-agency/new-agency-form';
import { PARTNER_FEES_FORM_FIELDS } from '../new-partner/partner-fees-form';
import { PARTNER_BANK_FORM_FIELD } from '../new-partner/partner-bank-form';
import { FINANCIAL_ACCOUNT_FORM_FIELD } from '../financial-account/financial-account-form';
import { ORDERS_FILTERS_FORM_FIELDS } from '../order/order-filters-form';
import { DateRange } from 'rsuite/DateRangePicker';
import { PROVIDER_FORM_FIELDS } from '../provider/provider-form';
import { ItemDataType } from 'rsuite/CascadeTree';
import { TypeAttributes } from 'rsuite/cjs/internals/types';
import { SIGN_UP_FORM_FIELD } from '../sign-up/sign-up-form';
import { QUICK_APPLICATION_FORM_FIELDS } from './quick-application/quick-application-form';
import {
	IBusinessModel,
	IProductInformation,
	ITransactionInformation,
} from '../application-view/application-view-form';
import { BUSINESS_FORM_FIELDS } from '../merchant/business-form';
import { ADDRESS_FORM_FIELDS } from '../merchant/address-form';
import { CUSTOMER_FORM_FIELDS } from '../merchant/customer-support-form';
import { DEVELOPER_FORM_FIELDS as MERCHANT_DEVELOPER_FORM_FIELDS } from '../merchant/developer-form';
import { IApplicationDetailsData } from '../../interfaces/merchant';
import { validateUrl } from '../../utils/validators';
import { isUSCountry } from '../../utils/utilities';

export enum FORM_FIELDS {
	COMPANY_NAME = 'LegalEntityName',
	DOING_BUSINESS = 'Dba',
	ANNUAL_SALES_VOLUME = 'AnnualSalesVolume',
	DECLINE_RATE = 'DeclineRate',
	TAX = 'TaxId',
	IS_BASED_IN_US = 'LegalEntityCountry',
	// BUSINESS_TYPE = 'Type',
	PLATFORM = 'EcommercePlatform',
	BUSINESS_ESTABLISHED_DATE = 'BusinessEstablishedDate',
	// TIME_IN_BUSINESS = 'TimeInBusiness',
	// PLATFORM_USAGE_PERIOD = 'EcommercePlatformUsagePeriod',
	// WEB_URL = 'Website',
	SITE_VERIFICATION = 'isSiteValidated',
	DESCRIPTOR = 'Descriptor',
	MCC = 'Mcc',
	DESCRIPTION = 'Description',
	LOGO = 'LogoFile',
	LOGO_URL = 'LogoUrl',
	PCI_DSS = 'Pcidss',

	ACCOUNT_ID = 'AccountId',
	PARTNER_ID = 'PartnerId',
	INTEGRATION_PARTNER = 'IntegrationPartnerId',
	SALES_AGENCY_ID = 'salesAgencyId',
	INTEGRATION_TIER = 'IntegrationTier',
	ACCOUNT_MANAGER = 'AccountManagerId',
	CRM_ID = 'CrmId',
	EXTERNAL_MERCHANT_IDENTIFIER = 'externalMerchantIdentifier',

	FIRST_NAME = 'PrimaryContactFirstName',
	LAST_NAME = 'PrimaryContactLastName',
	EMAIL = 'PrimaryContactEmail',
	PHONE = 'PrimaryContactPhone',

	DEVELOPER_FIRST_NAME = 'DeveloperContactDeveloperFirstName',
	DEVELOPER_LAST_NAME = 'DeveloperContactDeveloperLastName',
	DEVELOPER_EMAIL = 'DeveloperContactDeveloperEmail',
	DEVELOPER_PHONE = 'DeveloperContactDeveloperPhone',

	CUSTOMER_NAME = 'CustomerSupportInformationCustomerSupportName',
	SUPPORT_LINK = 'CustomerSupportInformationCustomerSupportLink',
	CUSTOMER_EMAIL = 'CustomerSupportInformationCustomerSupportEmail',
	CUSTOMER_PHONE = 'CustomerSupportInformationCustomerSupportPhone',

	// INDUSTRY = 'BusinessModelIndustry',
	URL_NUMBER = 'BusinessModelUrlCount',
	// INFO_AVAILABLE = 'BusinessModelInfoDisclosed',
	URLS = 'BusinessModelUrls',

	OTHER_INFORMATION = 'otherInformation',

	// MAX_SUBSCRIPTION_DURATION = 'ProductInfoMaxSubDuration',
	// IS_TRIAL_PERIOD = 'ProductInfoTrialPeriod',
	// AVERAGE_PRODUCT = 'ProductInfoAvgDeliveryTime',
	// PRODUCTS_SOLD = 'ProductInfoProductsSold',
	IS_REGULATED = 'ProductInfoRegulated',
	IS_RELATED_TO_HEALTH = 'ProductInfoHealthcare',

	MONTHLY_VOLUME = 'TransactionInformationAvgSales',
	MONTHLY_DECLINES = 'TransactionInformationAvgDeclineRate',
	MONTHLY_TRANSACTIONS = 'TransactionInformationAvgTransactionAmount',
	RETURN_RATE = 'TransactionInformationReturnsPercent',
	CHARGEBACK_RATE = 'TransactionInformationChargebackPercentage',

	DDA_TYPE = 'BankAccountInformationDdaType',
	ACCOUNT_NUMBER = 'BankAccountInformationAccountNumber',
	MASKED_ACCOUNT_NUMBER = 'maskedAccountNumber',
	MASKED_ROUTING_NUMBER = 'maskedRoutingNumber',
	ROUTING_NUMBER = 'BankAccountInformationRoutingNumber',
	BANK_NAME = 'BankAccountInformationBankName',


	LINE_1 = 'AddressLine1',
	LINE_2 = 'AddressLine2',
	CITY = 'AddressCity',
	ZIPCODE = 'AddressZipCode',
	COUNTRY = 'AddressCountry',
	STATE = 'AddressState',

	SPECIAL_TERMS = 'SpecialTerms',

	FEE_PERCENTAGE = 'percentage',
	FEE_AMOUNT = 'feeAmount',
	MIN_FEE_AMOUNT = 'minFeeAmount',
	CHARGEBACK = 'chargeback',
	REFUND_FEE = 'refundFee',
	RISK_FEE = 'riskFee',
	FEE_PERCENTAGE_ID = 'percentageId',
	FEE_AMOUNT_ID = 'feeAmountId',
	CHARGEBACK_ID = 'chargebackId',
	REFUND_FEE_ID = 'refundFeeId',
	RISK_FEE_ID = 'riskFeeId',
	CONTRACT_ALREADY_SIGNED = 'contractAlreadySigned',
	INTEGRATION_PARTNER_PARTICIPATE_SALE = 'integrationPartnerParticipateSale',
	DOCUMENTS = 'Documents',
}

export enum FORM_FIELDS_NAMES {
	COMPANY_NAME = 'NEW_APPLICATION.LABEL.COMPANY_NAME',
	DOING_BUSINESS = 'NEW_APPLICATION.LABEL.DOING_BUSINESS',
	ANNUAL_SALES_VOLUME = 'NEW_APPLICATION.LABEL.ANNUAL_SALES_VOLUME',
	TAX = 'NEW_APPLICATION.LABEL.TAX',
	IS_BASED_IN_US = 'NEW_APPLICATION.LABEL.IS_BASED_IN_US',
	IS_BASED_IN_US_TOOLTIP = 'NEW_APPLICATION.LABEL.IS_BASED_IN_US_TOOLTIP',
	// BUSINESS_TYPE = 'NEW_APPLICATION.LABEL.BUSINESS_TYPE',
	PLATFORM = 'NEW_APPLICATION.LABEL.PLATFORM',
	BUSINESS_ESTABLISHED_DATE = 'NEW_APPLICATION.LABEL.BUSINESS_ESTABLISHED_DATE',
	TIME_IN_BUSINESS = 'NEW_APPLICATION.LABEL.TIME_IN_BUSINESS',
	PLATFORM_USAGE_PERIOD = 'NEW_APPLICATION.LABEL.PLATFORM_USAGE_PERIOD',
	PLATFORM_USAGE_PERIOD_TOOLTIP = 'NEW_APPLICATION.LABEL.PLATFORM_USAGE_PERIOD_TOOLTIP',
	// WEB_URL = 'NEW_APPLICATION.LABEL.WEB_URL',
	SITE_VERIFICATION = 'NEW_APPLICATION.LABEL.SITE_VERIFICATION',
	DESCRIPTOR = 'NEW_APPLICATION.LABEL.DESCRIPTOR',
	MCC = 'NEW_APPLICATION.LABEL.MCC',
	DESCRIPTION = 'NEW_APPLICATION.LABEL.DESCRIPTION',
	LOGO = 'NEW_APPLICATION.LABEL.LOGO',
	PCI_DSS = 'NEW_APPLICATION.LABEL.PCI_DSS',

	ACCOUNT_ID = 'Account',
	PARTNER_ID = 'NEW_APPLICATION.LABEL.PARTNER_ID',
	INTEGRATION_PARTNER = 'NEW_APPLICATION.LABEL.INTEGRATION_PARTNER',
	SALES_AGENCY_ID = 'Sales Agency',
	INTEGRATION_TIER = 'NEW_APPLICATION.LABEL.INTEGRATION_TIER',
	ACCOUNT_MANAGER = 'NEW_APPLICATION.LABEL.ACCOUNT_MANAGER',
	CRM_ID = 'NEW_APPLICATION.LABEL.CRM_ID',
	EXTERNAL_MERCHANT_IDENTIFIER = 'NEW_APPLICATION.LABEL.EXTERNAL_MERCHANT_IDENTIFIER',

	// INDUSTRY = 'NEW_APPLICATION.LABEL.INDUSTRY',
	URL_NUMBER = 'NEW_APPLICATION.LABEL.URL_NUMBER',
	URL_NUMBER_PLACEHOLDER = 'NEW_APPLICATION.LABEL.URL_NUMBER_PLACEHOLDER',
	URL_NUMBER_TOOLTIP = 'NEW_APPLICATION.LABEL.URL_NUMBER_TOOLTIP',
	// INFO_AVAILABLE = 'NEW_APPLICATION.LABEL.INFO_AVAILABLE',
	// INFO_AVAILABLE_TOOLTIP = 'NEW_APPLICATION.LABEL.INFO_AVAILABLE_TOOLTIP',
	URLS = 'NEW_APPLICATION.LABEL.URLS',
	URLS_EDIT = 'NEW_APPLICATION.LABEL.URLS_EDIT',

	OTHER_PLACEHOLDER = 'NEW_APPLICATION.LABEL.OTHER_PLACEHOLDER',
	// MAX_SUBSCRIPTION_DURATION = 'NEW_APPLICATION.LABEL.MAX_SUBSCRIPTION_DURATION',
	IS_TRIAL_PERIOD = 'NEW_APPLICATION.LABEL.IS_TRIAL_PERIOD',
	AVERAGE_PRODUCT = 'NEW_APPLICATION.LABEL.AVERAGE_PRODUCT',
	AVERAGE_PRODUCT_TOOLTIP = 'NEW_APPLICATION.LABEL.AVERAGE_PRODUCT_TOOLTIP',
	PRODUCTS_SOLD = 'NEW_APPLICATION.LABEL.PRODUCTS_SOLD',
	IS_REGULATED = 'NEW_APPLICATION.LABEL.IS_REGULATED',
	IS_REGULATED_TOOLTIP = 'NEW_APPLICATION.LABEL.IS_REGULATED_TOOLTIP',
	IS_RELATED_TO_HEALTH = 'NEW_APPLICATION.LABEL.IS_RELATED_TO_HEALTH',
	IS_RELATED_TO_HEALTH_TOOLTIP = 'NEW_APPLICATION.LABEL.IS_RELATED_TO_HEALTH_TOOLTIP',

	MONTHLY_VOLUME = 'NEW_APPLICATION.LABEL.MONTHLY_VOLUME',
	MONTHLY_VOLUME_PLACEHOLDER = 'NEW_APPLICATION.LABEL.MONTHLY_VOLUME_PLACEHOLDER',
	MONTHLY_DECLINES = 'NEW_APPLICATION.LABEL.MONTHLY_DECLINES',
	MONTHLY_DECLINES_PLACEHOLDER = 'NEW_APPLICATION.LABEL.MONTHLY_DECLINES_PLACEHOLDER',
	MONTHLY_TRANSACTIONS = 'NEW_APPLICATION.LABEL.MONTHLY_TRANSACTIONS',
	RETURN_RATE = 'NEW_APPLICATION.LABEL.RETURN_RATE',
	CHARGEBACK_RATE = 'NEW_APPLICATION.LABEL.CHARGEBACK_RATE',
	CHARGEBACK_RATE_PLACEHOLDER = 'NEW_APPLICATION.LABEL.CHARGEBACK_RATE_PLACEHOLDER',
	DECLINE_RATE = 'NEW_APPLICATION.LABEL.DECLINE_RATE',
	DECLINE_RATE_PLACEHOLDER = 'NEW_APPLICATION.LABEL.DECLINE_RATE_PLACEHOLDER',

	LINE_1 = 'NEW_APPLICATION.LABEL.LINE_1',
	LINE_2 = 'NEW_APPLICATION.LABEL.LINE_2',
	CITY = 'NEW_APPLICATION.LABEL.CITY',
	ZIPCODE = 'NEW_APPLICATION.LABEL.ZIPCODE',
	COUNTRY = 'NEW_APPLICATION.LABEL.COUNTRY',
	STATE = 'NEW_APPLICATION.LABEL.STATE',
	FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.PHONE',
	DDA_TYPE = 'NEW_APPLICATION.LABEL.DDA_TYPE',
	ACCOUNT_NUMBER = 'NEW_APPLICATION.LABEL.ACCOUNT_NUMBER',
	ROUTING_NUMBER = 'NEW_APPLICATION.LABEL.ROUTING_NUMBER',
	BANK_NAME = 'NEW_APPLICATION.LABEL.BANK_NAME',
	SPECIAL_TERMS = 'NEW_APPLICATION.LABEL.SPECIAL_TERMS',
	CUSTOMER_NAME = 'NEW_APPLICATION.LABEL.CUSTOMER_NAME',
	SUPPORT_LINK = 'NEW_APPLICATION.LABEL.SUPPORT_LINK',
	CUSTOMER_EMAIL = 'NEW_APPLICATION.LABEL.CUSTOMER_EMAIL',
	CUSTOMER_PHONE = 'NEW_APPLICATION.LABEL.CUSTOMER_PHONE',
	CUSTOMER_NAME_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_NAME_TOOLTIP',
	SUPPORT_LINK_TOOLTIP = 'NEW_APPLICATION.LABEL.SUPPORT_LINK_TOOLTIP',
	CUSTOMER_EMAIL_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_EMAIL_TOOLTIP',
	CUSTOMER_PHONE_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_PHONE_TOOLTIP',
	DEVELOPER_FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	DEVELOPER_LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	DEVELOPER_EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	DEVELOPER_PHONE = 'NEW_APPLICATION.LABEL.PHONE',

	FEE_PERCENTAGE = 'FEES.PERCENTAGE',
	FEE_PERCENTAGE_TOOLTIP = 'FEES.PERCENTAGE_TOOLTIP',
	FEE_AMOUNT = 'FEES.FEE_AMOUNT',
	FEE_AMOUNT_TOOLTIP = 'FEES.FEE_AMOUNT_TOOLTIP',
	MIN_FEE_AMOUNT = 'FEES.MIN_FEE_AMOUNT',
	MIN_FEE_AMOUNT_TOOLTIP = 'FEES.MIN_FEE_AMOUNT_TOOLTIP',
	CHARGEBACK = 'FEES.CHARGEBACK',
	CHARGEBACK_TOOLTIP = 'FEES.CHARGEBACK_TOOLTIP',
	REFUND_FEE = 'FEES.REFUND_FEE',
	REFUND_FEE_TOOLTIP = 'FEES.REFUND_FEE_TOOLTIP',
	RISK_FEE = 'FEES.RISK_FEE',
	RISK_FEE_TOOLTIP = 'FEES.RISK_FEE_TOOLTIP',

	CONTRACT_ALREADY_SIGNED = 'NEW_APPLICATION.LABEL.CONTRACT_ALREADY_SIGNED',
	INTEGRATION_PARTNER_PARTICIPATE_SALE = 'NEW_APPLICATION.LABEL.INTEGRATION_PARTNER_PARTICIPATE_SALE',
}

// @ts-ignore
export const getPartnerAdminApplicationDetailsSchema = (t: TFunction): Yup.SchemaOf<IApplicationDetails> => Yup.object<Shape<IApplicationDetails>>().shape({
	[FORM_FIELDS.COMPANY_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.COMPANY_NAME_REQUIRED'))
		.max(100, t('NEW_APPLICATION.VALIDATION.COMPANY_NAME_LENGTH')),
	[FORM_FIELDS.DOING_BUSINESS]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.DOING_BUSINESS_REQUIRED'))
		.max(100, t('NEW_APPLICATION.VALIDATION.DOING_BUSINESS_LENGTH')),
	[FORM_FIELDS.ANNUAL_SALES_VOLUME]: Yup.number()
		.min(0, t('NEW_APPLICATION.VALIDATION.MIN_VALUE'))
		.required(t('NEW_APPLICATION.VALIDATION.ANNUAL_SALES_VOLUME_REQUIRED')),
		// .min(0, t('NEW_APPLICATION.VALIDATION.MIN_VALUE'))
		// .max(1000000000, t('NEW_APPLICATION.VALIDATION.MAX_VALUE')),
	[FORM_FIELDS.TAX]: Yup.string(),
	[FORM_FIELDS.IS_BASED_IN_US]: Yup.string(),

	// [FORM_FIELDS.WEB_URL]: Yup.string()
	// 	// .required(t('NEW_APPLICATION.VALIDATION.WEB_URL_REQUIRED'))
	// 	.url(t('NEW_APPLICATION.VALIDATION.WEB_URL_FORMAT')),
	[FORM_FIELDS.MCC]: Yup.string()
		.typeError(t('NEW_APPLICATION.VALIDATION.MCC_REQUIRED')),
		// .required(t('NEW_APPLICATION.VALIDATION.MCC_REQUIRED')),
	[FORM_FIELDS.DESCRIPTOR]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.DESCRIPTOR_REQUIRED')),

	[QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.INTEGRATION_TIER_REQUIRED')),
	// [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: Yup.string()
	// 	.required(t('NEW_APPLICATION.VALIDATION.ACCOUNT_MANAGER_REQUIRED')),
	// [FORM_FIELDS.PARTNER_ID]: Yup.string()
	// 	.required(t('NEW_APPLICATION.VALIDATION.PARTNER_ID_REQUIRED')),
	[FORM_FIELDS.INTEGRATION_PARTNER]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.INTEGRATION_PARTNER_REQUIRED')),

	[FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.FIRST_NAME_REQUIRED')),
	[FORM_FIELDS.LAST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.LAST_NAME_REQUIRED')),
	[FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
	[FORM_FIELDS.CUSTOMER_NAME]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.CUSTOMER_NAME_REQUIRED')),
	[FORM_FIELDS.SUPPORT_LINK]: Yup.string()
		// .url(t('NEW_APPLICATION.VALIDATION.SUPPORT_LINK_FORMAT')),
	.test('valid url', t('NEW_APPLICATION.VALIDATION.URLS_FORMAT'), (item) => !item || validateUrl(item))
		.typeError(t('NEW_APPLICATION.VALIDATION.WHITELISTED_URLS_REQUIRED')),
		// .required(t('NEW_APPLICATION.VALIDATION.CUSTOMER_LINK_REQUIRED')),
	[FORM_FIELDS.CUSTOMER_EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT')),
		// .required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[FORM_FIELDS.CUSTOMER_PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT')),
		// .required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
	[FORM_FIELDS.DEVELOPER_EMAIL]: Yup.string()
		.typeError(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT')),
	[FORM_FIELDS.DEVELOPER_PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT')),
	[FORM_FIELDS.URLS]: Yup.array(),
		// .test('valid url', t('NEW_APPLICATION.VALIDATION.SITES_FORMAT'), (item) => {
		// 	const res = item?.some(el => !isValidHttpUrl(el));
		// 	return !res;
		// })
	[FORM_FIELDS.MONTHLY_VOLUME]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_VOLUME_REQUIRED')),
	[FORM_FIELDS.MONTHLY_DECLINES]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_DECLINES_REQUIRED')),
	[FORM_FIELDS.MONTHLY_TRANSACTIONS]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_TRANSACTIONS_REQUIRED')),
	[FORM_FIELDS.RETURN_RATE]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.RETURN_RATE_REQUIRED')),
	[FORM_FIELDS.CHARGEBACK_RATE]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.CHARGEBACK_RATE_REQUIRED')),
	[FORM_FIELDS.DECLINE_RATE]: Yup.mixed()
		.test('is-number', t('NEW_APPLICATION.VALIDATION.DECLINE_RATE_INVALID'), (value) => {
			if (value === '' || value === null || value === undefined) return true;
			const numValue = Number(value);
			return !isNaN(numValue) && numValue >= 0 && numValue <= 100;
		}),
	[FORM_FIELDS.FEE_PERCENTAGE]: Yup.number()
		.required(t('FEES.VALIDATION.FEE_PERCENTAGE_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE'))
		.max(100, t('FEES.VALIDATION.MAX_VALUE')),
	[FORM_FIELDS.FEE_AMOUNT]: Yup.number()
		.required(t('FEES.VALIDATION.FEE_AMOUNT_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE')),
	[FORM_FIELDS.MIN_FEE_AMOUNT]: Yup.number()
		.required(t('FEES.VALIDATION.MIN_FEE_AMOUNT_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE')),
	[FORM_FIELDS.CHARGEBACK]: Yup.number()
		.required(t('FEES.VALIDATION.CHARGEBACK_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE')),
	[FORM_FIELDS.REFUND_FEE]: Yup.number()
		.required(t('FEES.VALIDATION.REFUND_FEE_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE')),
	[FORM_FIELDS.RISK_FEE]: Yup.number()
		.required(t('FEES.VALIDATION.RISK_FEE_REQUIRED'))
		.min(0, t('FEES.VALIDATION.MIN_VALUE'))
		.max(100, t('FEES.VALIDATION.MAX_VALUE')),
	[FORM_FIELDS.FEE_PERCENTAGE_ID]: Yup.string(),
	[FORM_FIELDS.FEE_AMOUNT_ID]: Yup.string(),
	[FORM_FIELDS.CHARGEBACK_ID]: Yup.string(),
	[FORM_FIELDS.REFUND_FEE_ID]: Yup.string(),
	[FORM_FIELDS.RISK_FEE_ID]: Yup.string(),
	[FORM_FIELDS.URLS]: Yup.array().of(Yup.string())
		.test('valid url', t('NEW_APPLICATION.VALIDATION.URLS_FORMAT'), (item) => {
			const res = item.some(el => !validateUrl(el));
			return !res;
		})
		.typeError(t('NEW_APPLICATION.VALIDATION.WHITELISTED_URLS_REQUIRED')),
	[FORM_FIELDS.CRM_ID]: Yup.string()
});

export const getAdminApplicationDetailsSchema = (t: TFunction): Yup.SchemaOf<IApplicationDetails> => Yup.object<Shape<IApplicationDetails>>().shape({
	...getPartnerAdminApplicationDetailsSchema(t).fields,
	[QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.ACCOUNT_MANAGER_REQUIRED')),
	[FORM_FIELDS.PARTNER_ID]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.PARTNER_ID_REQUIRED')),
});

export type IApplicationDetails = {
	[FORM_FIELDS.COMPANY_NAME]: string,
	[FORM_FIELDS.DOING_BUSINESS]: string,
	[FORM_FIELDS.ANNUAL_SALES_VOLUME]: string | number,
	[FORM_FIELDS.TAX]: string,
	[FORM_FIELDS.IS_BASED_IN_US]: string,
	// [FORM_FIELDS.BUSINESS_TYPE]: string,
	[FORM_FIELDS.PLATFORM]: string,
	[FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]: Date,
	// [FORM_FIELDS.TIME_IN_BUSINESS]?: string,
	// [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: string,
	// [FORM_FIELDS.WEB_URL]: string,
	[FORM_FIELDS.SITE_VERIFICATION]: boolean,
	[FORM_FIELDS.DESCRIPTOR]: string,
	[FORM_FIELDS.MCC]: string,
	[FORM_FIELDS.DESCRIPTION]: string,
	[FORM_FIELDS.LOGO]: string,
	[FORM_FIELDS.LOGO_URL]: string,
	[FORM_FIELDS.PCI_DSS]: boolean,

	[FORM_FIELDS.ACCOUNT_ID]: string,
	[FORM_FIELDS.PARTNER_ID]: string,
	[FORM_FIELDS.INTEGRATION_PARTNER]: string,
	[FORM_FIELDS.SALES_AGENCY_ID]: string,
	[FORM_FIELDS.INTEGRATION_TIER]: string,
	[FORM_FIELDS.ACCOUNT_MANAGER]: string,

	[FORM_FIELDS.FIRST_NAME]: string,
	[FORM_FIELDS.LAST_NAME]: string,
	[FORM_FIELDS.EMAIL]: string,
	[FORM_FIELDS.PHONE]: string,

	[FORM_FIELDS.DEVELOPER_FIRST_NAME]: string,
	[FORM_FIELDS.DEVELOPER_LAST_NAME]: string,
	[FORM_FIELDS.DEVELOPER_EMAIL]: string,
	[FORM_FIELDS.DEVELOPER_PHONE]: string,

	[FORM_FIELDS.CUSTOMER_NAME]: string,
	[FORM_FIELDS.SUPPORT_LINK]: string,
	[FORM_FIELDS.CUSTOMER_EMAIL]: string,
	[FORM_FIELDS.CUSTOMER_PHONE]: string,

	// [FORM_FIELDS.INDUSTRY]: string,
	[FORM_FIELDS.URL_NUMBER]: string,
	// [FORM_FIELDS.INFO_AVAILABLE]: string,
	[FORM_FIELDS.URLS]: string[],

	[FORM_FIELDS.OTHER_INFORMATION]: string,
	// [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: string,
	// [FORM_FIELDS.IS_TRIAL_PERIOD]: string,
	// [FORM_FIELDS.AVERAGE_PRODUCT]: string,
	// [FORM_FIELDS.PRODUCTS_SOLD]: string,
	[FORM_FIELDS.IS_REGULATED]: string,
	[FORM_FIELDS.IS_RELATED_TO_HEALTH]: string,

	[FORM_FIELDS.MONTHLY_VOLUME]: string,
	[FORM_FIELDS.MONTHLY_DECLINES]: string,
	[FORM_FIELDS.MONTHLY_TRANSACTIONS]: string,
	[FORM_FIELDS.RETURN_RATE]: string,
	[FORM_FIELDS.CHARGEBACK_RATE]: string,
	[FORM_FIELDS.DECLINE_RATE]: string | number,

	[FORM_FIELDS.DDA_TYPE]: string,
	[FORM_FIELDS.ACCOUNT_NUMBER]: string,
	[FORM_FIELDS.MASKED_ACCOUNT_NUMBER]: string,
	[FORM_FIELDS.MASKED_ROUTING_NUMBER]: string,
	[FORM_FIELDS.ROUTING_NUMBER]: string,
	[FORM_FIELDS.BANK_NAME]: string,

	[FORM_FIELDS.LINE_1]: string,
	[FORM_FIELDS.LINE_2]: string,
	[FORM_FIELDS.CITY]: string,
	[FORM_FIELDS.ZIPCODE]: string,
	[FORM_FIELDS.COUNTRY]: string,
	[FORM_FIELDS.STATE]: string,

	[FORM_FIELDS.SPECIAL_TERMS]: string,

	[FORM_FIELDS.FEE_PERCENTAGE]?: string | number;
	[FORM_FIELDS.FEE_AMOUNT]?: string | number;
	[FORM_FIELDS.MIN_FEE_AMOUNT]?: string | number;
	[FORM_FIELDS.CHARGEBACK]?: string | number;
	[FORM_FIELDS.REFUND_FEE]?: string | number;
	[FORM_FIELDS.RISK_FEE]?: string | number;
	[FORM_FIELDS.FEE_PERCENTAGE_ID]?: string;
	[FORM_FIELDS.FEE_AMOUNT_ID]?: string;
	[FORM_FIELDS.CHARGEBACK_ID]?: string;
	[FORM_FIELDS.REFUND_FEE_ID]?: string;
	[FORM_FIELDS.RISK_FEE_ID]?: string;

	[FORM_FIELDS.CONTRACT_ALREADY_SIGNED]?: boolean;
	[FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]?: boolean;
	[FORM_FIELDS.CRM_ID]?: string;
	[FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]?: string;
};

interface IInitialValuesProps {
	partnerId?: string,
	integrationPartnerId?: string,
}
export const getInitialValues = ({ partnerId, integrationPartnerId }: IInitialValuesProps): IApplicationDetails => ({
	[FORM_FIELDS.COMPANY_NAME]: '',
	[FORM_FIELDS.DOING_BUSINESS]: '',
	[FORM_FIELDS.ANNUAL_SALES_VOLUME]: '',
	[FORM_FIELDS.TAX]: '',
	[FORM_FIELDS.IS_BASED_IN_US]: '',
	// [FORM_FIELDS.BUSINESS_TYPE]: '',
	[FORM_FIELDS.PLATFORM]: '',
	[FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]: null,
	// [FORM_FIELDS.TIME_IN_BUSINESS]: '',
	// [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: '',
	// [FORM_FIELDS.WEB_URL]: '',
	[FORM_FIELDS.SITE_VERIFICATION]: false,
	[FORM_FIELDS.MCC]: '',
	[FORM_FIELDS.DESCRIPTOR]: '',
	[FORM_FIELDS.DESCRIPTION]: '',
	[FORM_FIELDS.LOGO]: '',
	[FORM_FIELDS.LOGO_URL]: '',
	[FORM_FIELDS.PCI_DSS]: false,

	[FORM_FIELDS.ACCOUNT_ID]: '',
	[FORM_FIELDS.PARTNER_ID]: partnerId || '',
	[FORM_FIELDS.INTEGRATION_PARTNER]: integrationPartnerId || '',
	[FORM_FIELDS.SALES_AGENCY_ID]: '',
	[FORM_FIELDS.INTEGRATION_TIER]: '',
	[FORM_FIELDS.ACCOUNT_MANAGER]: '',

	[FORM_FIELDS.FIRST_NAME]: '',
	[FORM_FIELDS.LAST_NAME]: '',
	[FORM_FIELDS.EMAIL]: '',
	[FORM_FIELDS.PHONE]: '',

	[FORM_FIELDS.DEVELOPER_FIRST_NAME]: '',
	[FORM_FIELDS.DEVELOPER_LAST_NAME]: '',
	[FORM_FIELDS.DEVELOPER_EMAIL]: '',
	[FORM_FIELDS.DEVELOPER_PHONE]: '',

	[FORM_FIELDS.CUSTOMER_NAME]: '',
	[FORM_FIELDS.SUPPORT_LINK]: '',
	[FORM_FIELDS.CUSTOMER_EMAIL]: '',
	[FORM_FIELDS.CUSTOMER_PHONE]: '',


	// [FORM_FIELDS.INDUSTRY]: '',
	[FORM_FIELDS.URL_NUMBER]: '',
	// [FORM_FIELDS.INFO_AVAILABLE]: '',
	[FORM_FIELDS.URLS]: [],

	[FORM_FIELDS.OTHER_INFORMATION]: '',
	// [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: '',
	// [FORM_FIELDS.IS_TRIAL_PERIOD]: '',
	// [FORM_FIELDS.AVERAGE_PRODUCT]: '',
	// [FORM_FIELDS.PRODUCTS_SOLD]: '',
	[FORM_FIELDS.IS_REGULATED]: '',
	[FORM_FIELDS.IS_RELATED_TO_HEALTH]: '',

	[FORM_FIELDS.MONTHLY_VOLUME]: '',
	[FORM_FIELDS.MONTHLY_DECLINES]: '',
	[FORM_FIELDS.MONTHLY_TRANSACTIONS]: '',
	[FORM_FIELDS.RETURN_RATE]: '',
	[FORM_FIELDS.CHARGEBACK_RATE]: '',
	[FORM_FIELDS.DECLINE_RATE]: '',

	[FORM_FIELDS.DDA_TYPE]: '',
	[FORM_FIELDS.ACCOUNT_NUMBER]: '',
	[FORM_FIELDS.ROUTING_NUMBER]: '',
	[FORM_FIELDS.MASKED_ACCOUNT_NUMBER]: '',
	[FORM_FIELDS.MASKED_ROUTING_NUMBER]: '',
	[FORM_FIELDS.BANK_NAME]: '',

	[FORM_FIELDS.LINE_1]: '',
	[FORM_FIELDS.LINE_2]: '',
	[FORM_FIELDS.CITY]: '',
	[FORM_FIELDS.ZIPCODE]: '',
	[FORM_FIELDS.COUNTRY]: 'US',
	[FORM_FIELDS.STATE]: '',

	[FORM_FIELDS.SPECIAL_TERMS]: '',

	[FORM_FIELDS.FEE_PERCENTAGE]: '',
	[FORM_FIELDS.FEE_AMOUNT]: '',
	[FORM_FIELDS.MIN_FEE_AMOUNT]: '',
	[FORM_FIELDS.CHARGEBACK]: '',
	[FORM_FIELDS.REFUND_FEE]: '',
	[FORM_FIELDS.RISK_FEE]: '',
	[FORM_FIELDS.FEE_PERCENTAGE_ID]: '',
	[FORM_FIELDS.FEE_AMOUNT_ID]: '',
	[FORM_FIELDS.CHARGEBACK_ID]: '',
	[FORM_FIELDS.REFUND_FEE_ID]: '',
	[FORM_FIELDS.RISK_FEE_ID]: '',

	[FORM_FIELDS.CONTRACT_ALREADY_SIGNED]: false,
	[FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]: false,
	[FORM_FIELDS.CRM_ID]: '',

	[FORM_FIELDS.DECLINE_RATE]: '',
	[FORM_FIELDS.ANNUAL_SALES_VOLUME]: '',
});

export interface IFeeForm {
  [FORM_FIELDS.FEE_PERCENTAGE]?: string | number;
  [FORM_FIELDS.FEE_AMOUNT]?: string | number;
  [FORM_FIELDS.MIN_FEE_AMOUNT]?: string | number;
  [FORM_FIELDS.CHARGEBACK]?: string | number;
  [FORM_FIELDS.REFUND_FEE]?: string | number;
  [FORM_FIELDS.RISK_FEE]?: string | number;
  [FORM_FIELDS.FEE_PERCENTAGE_ID]?: string;
  [FORM_FIELDS.FEE_AMOUNT_ID]?: string;
  [FORM_FIELDS.CHARGEBACK_ID]?: string;
  [FORM_FIELDS.REFUND_FEE_ID]?: string;
  [FORM_FIELDS.RISK_FEE_ID]?: string;
}

export const getFormattedFormFields = (formikValues): ApplicationFieldsReturnTypes => ({
	legalEntityName: formikValues?.[FORM_FIELDS.COMPANY_NAME],
	// companyName: formikValues?.[FORM_FIELDS.COMPANY_NAME],
	dba: formikValues?.[FORM_FIELDS.DOING_BUSINESS],
	annualSalesVolume: formikValues?.[FORM_FIELDS.ANNUAL_SALES_VOLUME],
	declineRate: formikValues?.[FORM_FIELDS.DECLINE_RATE] ? formikValues?.[FORM_FIELDS.DECLINE_RATE] : undefined,
	taxId: formikValues?.[FORM_FIELDS.TAX],
	legalEntityCountry: formikValues?.[FORM_FIELDS.IS_BASED_IN_US],
	// type: formikValues?.[FORM_FIELDS.BUSINESS_TYPE],
	ecommercePlatform: formikValues?.[FORM_FIELDS.PLATFORM],
	businessEstablishedDate: formikValues?.[FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]?.toISOString(),
	// ecommercePlatformUsagePeriod: formikValues?.[FORM_FIELDS.PLATFORM_USAGE_PERIOD],
	mcc: formikValues?.[FORM_FIELDS.MCC],
	descriptor: formikValues?.[FORM_FIELDS.DESCRIPTOR],
	// website: formikValues?.[FORM_FIELDS.WEB_URL] || null,
	isSiteValidated: formikValues?.[FORM_FIELDS.SITE_VERIFICATION],
	description: formikValues?.[FORM_FIELDS.DESCRIPTION],
	logoFile: formikValues?.[FORM_FIELDS.LOGO],
	logoUrl: formikValues?.[FORM_FIELDS.LOGO_URL],
	pcidss: formikValues?.[FORM_FIELDS.PCI_DSS],

	accountId: formikValues?.[FORM_FIELDS.ACCOUNT_ID] || null,
	partnerId: formikValues?.[FORM_FIELDS.PARTNER_ID],
	integrationPartnerId: formikValues?.[FORM_FIELDS.INTEGRATION_PARTNER] || null,
	salesAgencyId: formikValues?.[FORM_FIELDS.SALES_AGENCY_ID] || null,
	integrationTier: formikValues?.[FORM_FIELDS.INTEGRATION_TIER],
	accountManagerId: formikValues?.[FORM_FIELDS.ACCOUNT_MANAGER] || null,

	specialTerms: formikValues?.[FORM_FIELDS.SPECIAL_TERMS],
	urls: formikValues?.[FORM_FIELDS.URLS],
	contractAlreadySigned: formikValues?.[FORM_FIELDS.CONTRACT_ALREADY_SIGNED],
	integrationPartnerParticipateSale: formikValues?.[FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE],
	address: {
		line1: formikValues?.[FORM_FIELDS.LINE_1],
		line2: formikValues?.[FORM_FIELDS.LINE_2],
		zipCode: formikValues?.[FORM_FIELDS.ZIPCODE]?.toString(),
		state: isUSCountry(formikValues?.[FORM_FIELDS.COUNTRY]) ? formikValues?.[FORM_FIELDS.STATE] : null,
		stateCode: 'ST',
		city: formikValues?.[FORM_FIELDS.CITY],
		country: formikValues?.[FORM_FIELDS.COUNTRY],
	},
	primaryContact: {
		firstName: formikValues?.[FORM_FIELDS.FIRST_NAME],
		lastName: formikValues?.[FORM_FIELDS.LAST_NAME],
		email: formikValues?.[FORM_FIELDS.EMAIL],
		phone: formikValues?.[FORM_FIELDS.PHONE]
	},
	developerContact: {
		developerFirstName: formikValues?.[FORM_FIELDS.DEVELOPER_FIRST_NAME] ? formikValues?.[FORM_FIELDS.DEVELOPER_FIRST_NAME] : '',
		developerLastName: formikValues?.[FORM_FIELDS.DEVELOPER_LAST_NAME] ? formikValues?.[FORM_FIELDS.DEVELOPER_LAST_NAME] : '',
		developerEmail: formikValues?.[FORM_FIELDS.DEVELOPER_EMAIL] ? formikValues?.[FORM_FIELDS.DEVELOPER_EMAIL] : '',
		developerPhone: formikValues?.[FORM_FIELDS.DEVELOPER_PHONE] ? formikValues?.[FORM_FIELDS.DEVELOPER_PHONE] : ''
	},
	bankAccountInformation: {
		ddaType: formikValues?.[FORM_FIELDS.DDA_TYPE],
		accountNumber: formikValues?.[FORM_FIELDS.ACCOUNT_NUMBER] ? formikValues?.[FORM_FIELDS.ACCOUNT_NUMBER] : null,
		routingNumber: formikValues?.[FORM_FIELDS.ROUTING_NUMBER] ? formikValues?.[FORM_FIELDS.ROUTING_NUMBER] : null,
		maskedAccountNumber: formikValues?.[FORM_FIELDS.MASKED_ACCOUNT_NUMBER],
		maskedRoutingNumber: formikValues?.[FORM_FIELDS.MASKED_ROUTING_NUMBER],
		bankName: formikValues?.[FORM_FIELDS.BANK_NAME]
	},
	customerSupportInformation: {
		customerSupportName: formikValues?.[FORM_FIELDS.CUSTOMER_NAME],
		customerSupportLink: formikValues?.[FORM_FIELDS.SUPPORT_LINK],
		customerSupportEmail: formikValues?.[FORM_FIELDS.CUSTOMER_EMAIL],
		customerSupportPhone: formikValues?.[FORM_FIELDS.CUSTOMER_PHONE]
	},
	businessModel: {
		urlsCount: formikValues[FORM_FIELDS.URL_NUMBER],
		// industry: formikValues[FORM_FIELDS.INDUSTRY],
		urls: formikValues[FORM_FIELDS.URLS],
		// infoDisclosed: formikValues[FORM_FIELDS.INFO_AVAILABLE],
	},
	productInfo: {
		// maxSubDuration: formikValues[FORM_FIELDS.MAX_SUBSCRIPTION_DURATION],
		// trialPeriod: formikValues[FORM_FIELDS.IS_TRIAL_PERIOD],
		// avgDeliveryTime: formikValues[FORM_FIELDS.AVERAGE_PRODUCT],
		// productsSold: formikValues[FORM_FIELDS.PRODUCTS_SOLD],
		regulated: formikValues[FORM_FIELDS.IS_REGULATED],
		healthcare: formikValues[FORM_FIELDS.IS_RELATED_TO_HEALTH],
	},
	transactionInformation: {
		avgSales: formikValues[FORM_FIELDS.MONTHLY_VOLUME],
		avgDeclineRate: formikValues[FORM_FIELDS.MONTHLY_DECLINES],
		avgTransactionAmount: formikValues[FORM_FIELDS.MONTHLY_TRANSACTIONS],
		returnsPercent: formikValues[FORM_FIELDS.RETURN_RATE],
		chargebackPercentage: formikValues[FORM_FIELDS.CHARGEBACK_RATE],
		// avgDisputeRate: formikValues[FORM_FIELDS.DECLINE_RATE],
	},
	crmId: formikValues[FORM_FIELDS.CRM_ID],
	externalMerchantIdentifier: formikValues[FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER],
});

export const convertToApplicationInitialData = (data: IApplicationDetailsData): IApplicationDetails => ({
	[FORM_FIELDS.COMPANY_NAME]: data?.legalEntityName,
	[FORM_FIELDS.DOING_BUSINESS]: data?.dba,
	[FORM_FIELDS.ANNUAL_SALES_VOLUME]: data?.annualSalesVolume ?? '',
	[FORM_FIELDS.DECLINE_RATE]: data?.declineRate ? data?.declineRate : '',
	[FORM_FIELDS.TAX]: data?.taxId || '',
	[FORM_FIELDS.IS_BASED_IN_US]: data?.legalEntityCountry || '',
	// [FORM_FIELDS.BUSINESS_TYPE]: data?.type || '',
	[FORM_FIELDS.PLATFORM]: data?.ecommercePlatform || '',
	[FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]: data?.businessEstablishedDate && new Date(data?.businessEstablishedDate),
	// [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: data?.ecommercePlatformUsagePeriod || '',
	// [FORM_FIELDS.WEB_URL]: data?.website || '',
	[FORM_FIELDS.SITE_VERIFICATION]: data?.isSiteValidated,
	[FORM_FIELDS.DESCRIPTOR]: data?.descriptor || '',
	[FORM_FIELDS.MCC]: data?.mcc || '',
	[FORM_FIELDS.DESCRIPTION]: data?.description || '',
	[FORM_FIELDS.LOGO]: '',
	[FORM_FIELDS.LOGO_URL]: data?.logoUrl,
	[FORM_FIELDS.PCI_DSS]: data?.pcidss,

	[FORM_FIELDS.ACCOUNT_ID]: data?.accountId || '',
	[FORM_FIELDS.PARTNER_ID]: data?.partnerId || '',
	[FORM_FIELDS.INTEGRATION_PARTNER]: data?.integrationPartnerId || '',
	[FORM_FIELDS.SALES_AGENCY_ID]: data?.salesAgencyId || '',
	[FORM_FIELDS.INTEGRATION_TIER]: data?.integrationTier || '',
	[FORM_FIELDS.ACCOUNT_MANAGER]: data?.accountManagerId || '',

	[FORM_FIELDS.FIRST_NAME]: data?.primaryContact?.firstName ?? '',
	[FORM_FIELDS.LAST_NAME]: data?.primaryContact?.lastName ?? '',
	[FORM_FIELDS.EMAIL]: data?.primaryContact?.email ?? '',
	[FORM_FIELDS.PHONE]: data?.primaryContact?.phone ?? '',

	[FORM_FIELDS.DEVELOPER_FIRST_NAME]: data?.developerContact?.developerFirstName ?? '',
	[FORM_FIELDS.DEVELOPER_LAST_NAME]: data?.developerContact?.developerLastName ?? '',
	[FORM_FIELDS.DEVELOPER_EMAIL]: data?.developerContact?.developerEmail ?? '',
	[FORM_FIELDS.DEVELOPER_PHONE]: data?.developerContact?.developerPhone ?? '',

	[FORM_FIELDS.CUSTOMER_NAME]: data?.customerSupportInformation?.customerSupportName ?? '',
	[FORM_FIELDS.SUPPORT_LINK]: data?.customerSupportInformation?.customerSupportLink ?? '',
	[FORM_FIELDS.CUSTOMER_EMAIL]: data?.customerSupportInformation?.customerSupportEmail ?? '',
	[FORM_FIELDS.CUSTOMER_PHONE]: data?.customerSupportInformation?.customerSupportPhone ?? '',

	// [FORM_FIELDS.INDUSTRY]: data?.businessModel?.industry || '',
	[FORM_FIELDS.URL_NUMBER]: data?.businessModel?.urlsCount || '',
	// [FORM_FIELDS.INFO_AVAILABLE]: data?.businessModel?.infoDisclosed || '',
	[FORM_FIELDS.URLS]: data?.businessModel?.urls?.length ? data?.businessModel?.urls : [],

	[FORM_FIELDS.OTHER_INFORMATION]: '',
	// [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: data?.productInfo?.maxSubDuration ?? '',
	// [FORM_FIELDS.IS_TRIAL_PERIOD]: data?.productInfo?.trialPeriod ?? '',
	// [FORM_FIELDS.AVERAGE_PRODUCT]: data?.productInfo?.avgDeliveryTime ?? '',
	// [FORM_FIELDS.PRODUCTS_SOLD]: data?.productInfo?.productsSold ?? '',
	[FORM_FIELDS.IS_REGULATED]: data?.productInfo?.regulated ?? '',
	[FORM_FIELDS.IS_RELATED_TO_HEALTH]: data?.productInfo?.healthcare ?? '',

	[FORM_FIELDS.MONTHLY_VOLUME]: data?.transactionInformation?.avgSales ?? '',
	[FORM_FIELDS.MONTHLY_DECLINES]: data?.transactionInformation?.avgDeclineRate ?? '',
	[FORM_FIELDS.MONTHLY_TRANSACTIONS]: data?.transactionInformation?.avgTransactionAmount ?? '',
	[FORM_FIELDS.RETURN_RATE]: data?.transactionInformation?.returnsPercent ?? '',
	[FORM_FIELDS.CHARGEBACK_RATE]: data?.transactionInformation?.chargebackPercentage ?? '',

	[FORM_FIELDS.DDA_TYPE]: data?.bankAccountInformation ? data?.bankAccountInformation?.ddaType : '',
	[FORM_FIELDS.ACCOUNT_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.accountNumber : '',
	[FORM_FIELDS.MASKED_ACCOUNT_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.maskedAccountNumber : '',
	[FORM_FIELDS.MASKED_ROUTING_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.maskedRoutingNumber : '',
	[FORM_FIELDS.ROUTING_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.routingNumber : '',
	[FORM_FIELDS.BANK_NAME]: data?.bankAccountInformation ? data?.bankAccountInformation?.bankName : '',

	[FORM_FIELDS.LINE_1]: data?.address ? data?.address?.line1 : '',
	[FORM_FIELDS.LINE_2]: data?.address ? data?.address?.line2 : '',
	[FORM_FIELDS.CITY]: data?.address ? data?.address?.city : '',
	[FORM_FIELDS.ZIPCODE]: data?.address ? data?.address?.zipCode : '',
	[FORM_FIELDS.COUNTRY]: data?.address ? data?.address?.country : 'US',
	[FORM_FIELDS.STATE]: data?.address ? data?.address?.state : '',

	[FORM_FIELDS.SPECIAL_TERMS]: data?.specialTerms ? data?.specialTerms : '',
	[FORM_FIELDS.CONTRACT_ALREADY_SIGNED]: data?.contractAlreadySigned,
	[FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]: data?.integrationPartnerParticipateSale,
	[FORM_FIELDS.CRM_ID]: data?.crmId || '',
	[FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]: data?.externalMerchantIdentifier || '',
	[FORM_FIELDS.DECLINE_RATE]: data?.declineRate ?? '',
});

export const getFormattedFormikFeeData = (formikValues): any => {
	return ({
		percentage: formikValues[FORM_FIELDS.FEE_PERCENTAGE] ? Number(formikValues[FORM_FIELDS.FEE_PERCENTAGE]) : '',
		feeAmount: formikValues[FORM_FIELDS.FEE_AMOUNT] ? Number(formikValues[FORM_FIELDS.FEE_AMOUNT]) : '',
		minFeeAmount: formikValues[FORM_FIELDS.MIN_FEE_AMOUNT] ? Number(formikValues[FORM_FIELDS.MIN_FEE_AMOUNT]) : '',
		chargeback: formikValues[FORM_FIELDS.CHARGEBACK] ? Number(formikValues[FORM_FIELDS.CHARGEBACK]) : '',
		refundFee: formikValues[FORM_FIELDS.REFUND_FEE] ? Number(formikValues[FORM_FIELDS.REFUND_FEE]) : '',
		riskFee: formikValues[FORM_FIELDS.RISK_FEE] ? Number(formikValues[FORM_FIELDS.RISK_FEE]) : '',
		percentageId: formikValues[FORM_FIELDS.FEE_PERCENTAGE_ID] || '',
		feeAmountId: formikValues[FORM_FIELDS.FEE_AMOUNT_ID] || '',
		chargebackId: formikValues[FORM_FIELDS.CHARGEBACK_ID] || '',
		refundFeeId: formikValues[FORM_FIELDS.REFUND_FEE_ID] || '',
		riskFeeId: formikValues[FORM_FIELDS.RISK_FEE_ID] || '',
		contractAlreadySigned: formikValues[FORM_FIELDS.CONTRACT_ALREADY_SIGNED],
		integrationPartnerParticipateSale: formikValues[FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE],
		crmId: formikValues[FORM_FIELDS.CRM_ID] || '',
		externalMerchantIdentifier: formikValues[FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER] || '',
	});
};

export const convertToInitialFeeValues = (data): IFeeForm => {
	console.log('data', data);
	return ({
		[FORM_FIELDS.FEE_PERCENTAGE]: data?.percentage >= 0 ? String(data?.percentage) : '',
		[FORM_FIELDS.FEE_AMOUNT]: data?.feeAmount >= 0 ? String(data?.feeAmount) : '',
		[FORM_FIELDS.MIN_FEE_AMOUNT]: data?.minFeeAmount >= 0 ? String(data?.minFeeAmount) : '',
		[FORM_FIELDS.CHARGEBACK]: data?.chargeback >= 0 ? String(data?.chargeback) : '',
		[FORM_FIELDS.REFUND_FEE]: data?.refundFee >= 0 ? String(data?.refundFee) : '',
		[FORM_FIELDS.RISK_FEE]: data?.riskFee >= 0 ? String(data?.riskFee) : '',
		[FORM_FIELDS.FEE_PERCENTAGE_ID]: data?.percentageId,
		[FORM_FIELDS.FEE_AMOUNT_ID]: data?.feeAmountId,
		[FORM_FIELDS.CHARGEBACK_ID]: data?.chargebackId,
		[FORM_FIELDS.REFUND_FEE_ID]: data?.refundFeeId,
		[FORM_FIELDS.RISK_FEE_ID]: data?.riskFeeId,
	});
};


type formInputFieldName =
	FORM_FIELDS
	| PARTNER_FORM_FIELDS
	| SITE_FORM_FIELDS
	| PAYMENTS_GATEWAY_FORM_FIELDS
	| BANK_FORM_FIELD
	| CONTACT_FORM_FIELDS
	| USERS_FORM_FIELDS
	| AGENT_FORM_FIELDS
	| BUSINESS_INFO_FORM_FIELDS
	| DEVELOPER_FORM_FIELDS
	| CUSTOMER_SUPPORT_FORM_FIELDS
	| PROFILE_SETTINGS_FORM_FIELDS
	| ACCOUNT_FORM_FIELDS
	| CONTACT_PAGE_FORM_FIELDS
	| AGENCY_FORM_FIELD
	| PARTNER_FEES_FORM_FIELDS
	| PARTNER_BANK_FORM_FIELD
	| OWNER_FORM_FIELDS
	| ORDERS_FILTERS_FORM_FIELDS
	| FINANCIAL_ACCOUNT_FORM_FIELD
	| PROVIDER_FORM_FIELDS
	| SIGN_UP_FORM_FIELD
	| QUICK_APPLICATION_FORM_FIELDS
	| BUSINESS_FORM_FIELDS
	| ADDRESS_FORM_FIELDS
	| CUSTOMER_FORM_FIELDS
	| MERCHANT_DEVELOPER_FORM_FIELDS
	| CHANGE_PASSWORD_FORM_FIELDS;

export interface IFakeInputs {
	key: string;
	label: string;
	value: string | number;
	type?: 'date' | 'text';
	fakeInputAdditionalClass?: string
}

interface IFeesFields {
	amount: number,
	isStandard: boolean,
	chargeType: number,
	name: string,
	description: string,
	minimumFeeAmount?: number | null,
	type: number,
	id?: string
}

// TODO add interface
export const feesValue = ({ activeFee, nonStandardFee }): IFeesFields[] => {
	console.log('nonStandardFee', nonStandardFee);
	if (activeFee.feeType === FEE_TYPE.STANDARD) {
		return [];
	} else {
		return [
			{
				amount: nonStandardFee.percentage ? Math.round(nonStandardFee.percentage * 100) : 0,
				chargeType: 1,
				description: 'Percentage',
				isStandard: false,
				name: 'Percentage',
				type: 2,
				minimumFeeAmount: nonStandardFee.minFeeAmount !== '' ? Math.round(nonStandardFee.minFeeAmount * 100) : null,

			},
			{
				amount: nonStandardFee.feeAmount ? Math.round(nonStandardFee.feeAmount * 100) : 0,
				chargeType: 1,
				description: 'Fee Amount',
				isStandard: false,
				name: 'Fee Amount',
				type: 1
			},
			{
				amount: nonStandardFee.chargeback ? Math.round(nonStandardFee.chargeback * 100) : 0,
				chargeType: 3,
				description: 'Chargeback Fee',
				isStandard: false,
				name: 'Chargeback Fee',
				type: 1
			},
			{
				amount: nonStandardFee.refundFee ? Math.round(nonStandardFee.refundFee * 100) : 0,
				chargeType: 3,
				description: 'Refund Fee',
				isStandard: false,
				name: 'Refund Fee',
				type: 1
			},
			{
				amount: nonStandardFee.riskFee ? Math.round(nonStandardFee.riskFee * 100) : 0,
				chargeType: 3,
				description: 'Risk Fee',
				isStandard: false,
				name: 'Risk Fee',
				type: 1
			}
		];
	}
};

export const addedFeesValue = ({ activeFee, nonStandardFee, applicationId }): IFeesFields[] => {
	if (activeFee.feeType === FEE_TYPE.STANDARD) {
		return [];
	} else if (applicationId) {
		return [
			{
				amount: nonStandardFee.percentage ? Math.round(nonStandardFee.percentage * 100) : 0,
				chargeType: 1,
				description: 'Percentage',
				isStandard: false,
				name: 'Percentage',
				type: 2,
				minimumFeeAmount: nonStandardFee.minFeeAmount !== '' ? Math.round(nonStandardFee.minFeeAmount * 100) : null,
				id: nonStandardFee.percentageId
			},
			{
				amount: nonStandardFee.feeAmount ? Math.round(nonStandardFee.feeAmount * 100) : 0,
				chargeType: 1,
				description: 'Fee Amount',
				isStandard: false,
				name: 'Fee Amount',
				type: 1,
				id: nonStandardFee.feeAmountId
			},
			{
				amount: nonStandardFee.chargeback ? Math.round(nonStandardFee.chargeback * 100) : 0,
				chargeType: 3,
				description: 'Chargeback Fee',
				isStandard: false,
				name: 'Chargeback Fee',
				type: 1,
				id: nonStandardFee.chargebackId
			},
			{
				amount: nonStandardFee.refundFee ? Math.round(nonStandardFee.refundFee * 100) : 0,
				chargeType: 3,
				description: 'Refund Fee',
				isStandard: false,
				name: 'Refund Fee',
				type: 1,
				id: nonStandardFee.refundFeeId
			},
			{
				amount: nonStandardFee.riskFee ? Math.round(nonStandardFee.riskFee * 100) : 0,
				chargeType: 3,
				description: 'Risk Fee',
				isStandard: false,
				name: 'Risk Fee',
				type: 1,
				id: nonStandardFee.riskFeeId
			}
		];
	}
};

export interface ApplicationFieldsReturnTypes {
	id?: string,
	legalEntityName: string,
	// companyName: string,
	dba: string,
	annualSalesVolume: number,
	declineRate: number,
	taxId: string,
	legalEntityCountry: string,
	// type: string,
	ecommercePlatform: string,
	businessEstablishedDate: string,
	// ecommercePlatformUsagePeriod: string,
	mcc: string,
	descriptor: string,
	// website: string,
	isSiteValidated: boolean,
	description: string,
	logoFile: string,
	logoUrl?: string,
	pcidss: string,

	accountId: string,
	partnerId: string,
	integrationPartnerId: string,
	salesAgencyId: string,
	integrationTier: string,
	accountManagerId: string,

	specialTerms: string,
	statusName?: string,
	agreeToTerms?: string,
	createdOn?: string,

	operationsStatus?: string,
	riskStatus?: string,
	address: AddressTypes,
	primaryContact: PrimaryContactTypes,
	developerContact: DeveloperContactTypes,
	bankAccountInformation: BankAccountInformationTypes,
	customerSupportInformation: CustomerSupportInformationTypes,
	businessModel: IBusinessModel,
	transactionInformation: ITransactionInformation,
	productInfo: IProductInformation;
	urls?: string[],
	contractAlreadySigned?: boolean,
	integrationPartnerParticipateSale?: boolean,
	crmId?: string,
	externalMerchantIdentifier?: string,
}

type CustomerSupportInformationTypes = {
	customerSupportName: string,
	customerSupportLink: string,
	customerSupportEmail: string,
	customerSupportPhone: string
}

export type BankAccountInformationTypes = {
	ddaType: string,
	accountNumber: string,
	routingNumber: string,
	maskedAccountNumber: string,
	maskedRoutingNumber: string,
	bankName: string
}

type DeveloperContactTypes = {
	developerFirstName: string,
	developerLastName: string,
	developerEmail: string,
	developerPhone: string
};

type PrimaryContactTypes = {
	firstName: string,
	lastName: string,
	email: string,
	phone: string
}

export type AddressTypes = {
	line1: string,
	line2: string,
	zipCode: string,
	state: string,
	stateCode: string,
	city: string,
	country: string
}
